import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '@environment';
import {EnvService} from '../../env-service/env.service';

@Injectable({
  providedIn: 'root'
})
export class AppInsightsLoggerService {

  constructor(private http: HttpClient, private envService: EnvService) {}

  /**
   * This method is used to send logs from frontend to the Logging backend API
   * @param level Log Level
   * @param message Custom message
   * @param payload More detailed information that we want to send to the backend logging API.
   */
  log(level: string, message: string, payload: string) {

    const url = environment.getApiUrl(
      environment.uiLoggerUrl(),
      this.envService.mhsApiEndpoint,
      this.envService.apiSubscriptionId);

    const pl = {level, message, payload};

    this.http.post(url, pl)
    .toPromise()
    .then(result => {
      // console.log('Log message sent.');
    }, e => {
      console.error('Logging Service. Failed to post log message. Received Error Code status: ' + e.status);
    });
  }
}
